import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PersdataItemApiFrom } from '@api-gen/models/persdata-item-api-from';
import { SessionStorage } from '@core/storage/session-storage';
import { StorageKeys } from '@core/storage/storage.keys';
import { TranslateModule } from '@ngx-translate/core';
import { ModalTitleComponent } from '@shared/components/modal-title/modal-title.component';


@Component({
    selector: 'app-expires-privilege-dialog',
    standalone: true,
    templateUrl: './expires-privilege-dialog.component.html',
    styleUrls: ['./expires-privilege-dialog.component.scss'],
    imports: [MatDialogModule, ModalTitleComponent, TranslateModule, MatButtonModule],
})
export class ExpiresPrivilegeDialogComponent {
    @SessionStorage(StorageKeys.SkipExpiresPrivilegeFlag)
    public skipExpiresPrivilegeFlag: boolean;

    public readonly dialogData: { privileges: PersdataItemApiFrom[] } = inject(MAT_DIALOG_DATA);

    public gotIt(): void {
        this.skipExpiresPrivilegeFlag = true;
    }
}
